// extracted by mini-css-extract-plugin
export var buttonWrapper = "styles-module--button-wrapper--3c4c4";
export var gradientBorder = "styles-module--gradient-border--3be77";
export var peopleImage = "styles-module--people-image--2b17b";
export var subtitle = "styles-module--subtitle--a28e2";
export var title = "styles-module--title--5995f";
export var wrapper = "styles-module--wrapper--d4178";